import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';

const NFOList = ({ config }) => {
    const [nfos, setNfos] = useState([]);
    const [closedNfos, setClosedNfos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchNFOs();
    }, []);

    const fetchNFOs = async () => {
        try {
            const response = await axios.get(`${config.PY_API_URL}api/nfos/active?limit=${config.nfoListLimit || 10}&type=${config.showNFOListType || 'all'}`);
            if (response.data.status === 'success') {
                setNfos(response.data.data.nfos);
                setClosedNfos(response.data.data?.closed_nfos || []);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching NFOs:', error);
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return format(new Date(dateString), 'dd MMM yyyy');
    };

    if (loading) {
        return <div>Loading NFOs...</div>;
    }

    return (
        <>
        {(config.showNFOListType === 'active' || config.showNFOListType === 'all') && (
            <div className="nfo-list-container">
            <h3 className="nfo-section-title" style={{ fontSize: '24px', fontWeight: 'bold' }}>New Fund Offers</h3>
            <div className="nfo-list">
                {nfos.length > 0 ? (
                    nfos.map((nfo) => (
                        <div key={nfo.id} className="nfo-row">
                            <div className="nfo-row-content">
                                <div className="nfo-main-info" style={{ width: '100px', float: 'left' }}>
                                <img src={nfo.amc_logo} style={{ width: '60px', height: '60px', borderRadius: '10px', backgroundColor: '#f0f0f0' }} alt={nfo.amc_name} className="amc-logo" />                                
                            </div>
                            
                            <div className="nfo-row-details" style={{ width: `calc(100% - 100px)` , float: 'left', gap: '0px'}}>
                                <div className="nfo-main-info" style={{ width: '100%' }}>
                                    <h4 style={{ fontSize: '18px', fontWeight: 'bold' }}>{nfo.scheme_name}</h4>
                                </div>

                                <div className="detail-group">
                                    <div className="detail-item">
                                        <span className="label">Category</span>
                                        <span className="value">{nfo.schene_category}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="label">Type</span>
                                        <span className="value">{nfo.scheme_type}</span>
                                    </div>
                                </div>

                                <div className="detail-group">
                                    <div className="detail-item">
                                        <span className="label">Min. Investment</span>
                                        <span className="value">{nfo.miminum_subscription}</span>
                                    </div>
                                </div>

                                <div className="detail-group dates">
                                    <div className="detail-item">
                                        <span className="label">
                                            <i className="fas fa-calendar-alt"></i> Launch Date
                                        </span>
                                        <span className="value">{formatDate(nfo.launch_date)}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="label">
                                            <i className="fas fa-calendar-times"></i> Closes On
                                        </span>
                                        <span className="value highlight">{formatDate(nfo.closure_date)}</span>
                                    </div>
                                </div>

                                <div className="nfo-action">
                                    {nfo.website && (
                                        <a 
                                            href={nfo.website} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            className="nfo-invest-button"
                                        >
                                            Invest Now <i className="fas fa-arrow-right"></i>
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))) : (
                    <div className="nfo-row">
                        <div className="nfo-row-content">
                            <div className="nfo-main-info" style={{fontSize: '16px'}}>
                                <h4>No active NFO</h4>
                            </div>
                        </div>
                    </div>
                )}
                {nfos.length > 0 && config.nfoListLimit < 10 && nfos.length >= config.nfoListLimit && config.showNFOListType === 'active' && (
                    <div className="view-all-nfo-button-container" style={{textAlign: 'right'}}>
                        <a href={`${config.siteUrl}/nfo-list`} className="view-all-nfo-button">View All</a>
                    </div>
                )}
                </div>
            </div>
        )}

        {(config.showNFOListType === 'closed' || config.showNFOListType === 'all') && (
        <div className="nfo-list-container">
            <h3 className="nfo-section-title" style={{ fontSize: '24px', fontWeight: 'bold' }}>Recently Closed NFOs</h3>
            <div className="nfo-list">
                {closedNfos.length > 0 ? (
                    closedNfos.map((nfo) => (
                        <div key={nfo.id} className="nfo-row">
                            <div className="nfo-row-content">
                                <div className="nfo-main-info" style={{ width: '100px', float: 'left' }}>
                                <img src={nfo.amc_logo} style={{ width: '60px', height: '60px', borderRadius: '10px', backgroundColor: '#f0f0f0' }} alt={nfo.amc_name} className="amc-logo" />                                
                            </div>
                            
                            <div className="nfo-row-details" style={{ width: `calc(100% - 100px)` , float: 'left', gap: '0px'}}>
                                <div className="nfo-main-info" style={{ width: '100%' }}>
                                    <h4 style={{ fontSize: '18px', fontWeight: 'bold' }}>{nfo.scheme_name}</h4>
                                </div>

                                <div className="detail-group">
                                    <div className="detail-item">
                                        <span className="label">Category</span>
                                        <span className="value">{nfo.schene_category}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="label">Type</span>
                                        <span className="value">{nfo.scheme_type}</span>
                                    </div>
                                </div>

                                <div className="detail-group">
                                    <div className="detail-item">
                                        <span className="label">Min. Investment</span>
                                        <span className="value">{nfo.miminum_subscription}</span>
                                    </div>
                                </div>

                                <div className="detail-group dates">
                                    <div className="detail-item">
                                        <span className="label">
                                            <i className="fas fa-calendar-alt"></i> Launch Date
                                        </span>
                                        <span className="value">{formatDate(nfo.launch_date)}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="label">
                                            <i className="fas fa-calendar-times"></i> Closes On
                                        </span>
                                        <span className="value highlight">{formatDate(nfo.closure_date)}</span>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                ))) : (
                    <div className="nfo-row">
                        <div className="nfo-row-content">
                            <div className="nfo-main-info" style={{fontSize: '16px'}}>
                                <h4>No recently closed NFOs</h4>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
        )}
        </>
    );
};

export default NFOList; 